import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import {PopupType} from "../popups/popupType";
import {Application} from "../application";
import * as ko from "knockout";

export class OpenCostbooksPopupCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.OpenCostbooksPopup;
    canExecute = ko.computed(() => {
        return true;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        return this.app.popupsManager.show(PopupType.costbooks, false);
    }

    name = "Open costbook";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/openCostbooksPopupCommand.ts